/**
 * evenements.js
 * -------------
 * Calendrier institutionnel : evenements, referentiels, export iCalendar.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Événements d'établissement (module Planning, /api/evenements/) ── */

/** GET /evenements/ — calendrier institutionnel de l'établissement. */
export async function getEvenements(params = {}) {
  const { data } = await axiosClient.get("/evenements/", { params });
  return Array.isArray(data) ? data : data?.results || [];
}

/** POST /evenements/ — crée un événement (titre, date, heure, lieu, description). */
export async function creerEvenement(payload) {
  const { data } = await axiosClient.post("/evenements/", payload);
  return data;
}

/** PATCH /evenements/<id>/ — modifie un événement (statut, horaires, participants…). */
export async function modifierEvenement(id, payload) {
  const { data } = await axiosClient.patch(`/evenements/${id}/`, payload);
  return data;
}

/** DELETE /evenements/<id>/ */
export async function supprimerEvenement(id) {
  await axiosClient.delete(`/evenements/${id}/`);
}

/** GET /evenements/options/ — référentiels du formulaire (types, statuts, classes, participants). */
export async function getEvenementOptions() {
  const { data } = await axiosClient.get("/evenements/options/");
  return data || {};
}

/**
 * GET /evenements/ics/ — export iCalendar, mêmes filtres que la liste.
 * Renvoie le texte du calendrier ; le déclenchement du téléchargement est
 * laissé à l'appelant.
 */
export async function getEvenementsIcs(params = {}) {
  const { data } = await axiosClient.get("/evenements/ics/", {
    params,
    responseType: "text",
  });
  return data;
}
